


















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component
  export default class OneWishlistModalAdd extends Vue {
    wishlistName: string = ''

    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    progress!: boolean;

    @Prop({
      type: Number,
      required: false,
      default: 17,
    })
    max!: number;

    get isValid() {
      return this.wishlistName.trim().length < this.max
    }

    @Watch('value')
    onVisibilityChange() {
      this.wishlistName = ''
    }

    onSave() {
      this.$emit('create', this.wishlistName.trim())
    }
  }
